import { useTranslation } from 'react-i18next';

import { StylizedBulletList, Upsell } from '@ctct/ui-react';

import ComparisonTableStrategy from '../ComparisonTableStrategy';
import useUpgradeStepContentCopy from '../hooks/useUpgradeStepContentCopy';
import useUpsellImageUrl from '../hooks/useUpsellImageUrl';
import { useUpgradeContext } from '../UpgradeContext';
import UpgradeOrderSummary from '../UpgradeOrderSummary';
import { planNumberEnum } from '../utils';

const UpgradeStepContent = () => {
  const { t } = useTranslation();

  const [{ upgradeInfo, selectedPlanIdFromCompare, recommendedUpgradePlanPromotion }] = useUpgradeContext();
  const { recommendedPlanType, currentPlanType, recommendedPlanGroupId, recommendedPlanId } = upgradeInfo || {};

  const isPremium = selectedPlanIdFromCompare
    ? selectedPlanIdFromCompare === planNumberEnum.Premium
    : recommendedPlanType === 'BEST' || recommendedPlanType === 'GOLD';
  const isLiteToPremium = currentPlanType === 'BRONZE' && isPremium;
  const isLegacy = recommendedPlanType === 'BETTER' || recommendedPlanType === 'GOOD';

  const isLegacyToStandard = recommendedPlanGroupId === 183 && recommendedPlanId === 362;
  const isLegacyToPremium = recommendedPlanGroupId === 183 && recommendedPlanId === 363;

  const { featureList, title, description } = useUpgradeStepContentCopy({
    isPremium,
    isLiteToPremium,
    isLegacy,
    recommendedUpgradePlanPromotion,
    isLegacyToStandard,
    isLegacyToPremium,
  });

  const imageUrl = useUpsellImageUrl();

  return (
    <div className="upgrade-plan-container">
      <div className="upgrade-plan-main-body">
        <Upsell
          image={{ url: imageUrl, alt: t('upgrade-image-alt') }}
          data-qe-id="upgrade-intro-upsell"
          text={
            <div className="upgrade-step-content">
              <div style={{ flexBasis: '90%' }}>
                <span className="plan-name">{title}</span>
                <div>{description}</div>
                <div style={{ fontWeight: 700, paddingTop: 10, paddingBottom: 8 }}>
                  {t('upgrade-popup.included-features')}
                </div>
                <StylizedBulletList items={featureList} kind="success" />
              </div>
            </div>
          }
          backgroundColor="white"
        />
        <ComparisonTableStrategy isLegacy={isLegacy || isLegacyToPremium || isLegacyToStandard} />
      </div>

      <div className="order-summary-wrapper">
        <UpgradeOrderSummary showLegalTerms showTax showTotal data-qe-id="upgrade-order-summary" />
      </div>
    </div>
  );
};

UpgradeStepContent.propTypes = {};

export default UpgradeStepContent;
